import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { useTranslation } from 'react-i18next';
import logo from "../images/LAKCHE.png"; 
import ContactModal from './ContactModal';

const Footer = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      <footer className="bg-slate-900 text-slate-300">
        {/* Logo Section */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-12 sm:pt-16">
          <Link to="/" className="inline-block">
            <img
              src={logo}
              alt="Lak-Che Logo"
              className="h-10 sm:h-12 w-auto object-contain transition-opacity hover:opacity-80"
            />
          </Link>
        </div>

        {/* Footer Grid */}
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-8 sm:gap-10 lg:gap-12">

            {/* Address Section */}
            <div className="col-span-1 sm:col-span-2 lg:col-span-4">
              <h6 className="text-white font-bold mb-4 uppercase tracking-widest text-xs sm:text-sm">
                {t('footer.address_title')}
              </h6>

              <div className="text-slate-400 space-y-4 border-l-2 border-blue-600 pl-4 text-sm">
                <div>
                  <p className="text-white font-semibold mb-1">Canada</p>
                  <p className="leading-relaxed">2151 Rue Léger Lasalle</p>
                  <p className="leading-relaxed">Montréal, Québec H8N 0J8</p>
                </div>

                <div>
                  <p className="text-white font-semibold mb-1">Nigeria</p>
                  <p className="leading-relaxed">39 Alternative Road, Chevron</p>
                  <p className="leading-relaxed">Lekki, Lagos State</p>
                </div>
              </div>
            </div>

            {/* Links Section */}
            <div className="col-span-1 lg:col-span-2">
              <h6 className="text-white font-bold mb-4 sm:mb-6 text-xs sm:text-sm uppercase tracking-widest">
                {t('footer.links_title')}
              </h6>

              <ul className="space-y-3 sm:space-y-4 text-sm">
                <li>
                  <HashLink smooth to="/#about" className="hover:text-blue-400 transition-colors duration-300 inline-block">
                    {t('footer.links.about')}
                  </HashLink>
                </li>
                <li>
                  <HashLink smooth to="/#services" className="hover:text-blue-400 transition-colors duration-300 inline-block">
                    {t('footer.links.services')}
                  </HashLink>
                </li>
                <li>
                  <button 
                    onClick={() => setIsModalOpen(true)} 
                    className="hover:text-blue-400 transition-colors duration-300 text-left"
                  >
                    {t('footer.links.contact')}
                  </button>
                </li>
              </ul>
            </div>

            {/* Services Section */}
            <div className="col-span-1 lg:col-span-3">
              <h6 className="text-white font-bold mb-4 sm:mb-6 text-xs sm:text-sm uppercase tracking-widest">
                {t('footer.services_title')}
              </h6>

              <ul className="space-y-3 sm:space-y-4 text-sm">
                <li>
                  <HashLink smooth to="/#services" className="hover:text-blue-400 transition-colors duration-300 inline-block">
                    {t('footer.services.web_app')}
                  </HashLink>
                </li>
                <li>
                  <HashLink smooth to="/#services" className="hover:text-blue-400 transition-colors duration-300 inline-block">
                    {t('footer.services.ai_solutions')}
                  </HashLink>
                </li>
                <li>
                  <HashLink smooth to="/#services" className="hover:text-blue-400 transition-colors duration-300 inline-block">
                    {t('footer.services.blockchain')}
                  </HashLink>
                </li>
                <li>
                  <HashLink smooth to="/#services" className="hover:text-blue-400 transition-colors duration-300 inline-block">
                    {t('footer.services.ai_audit')}
                  </HashLink>
                </li>
              </ul>
            </div>

            {/* Social Section */}
            <div className="col-span-1 sm:col-span-2 lg:col-span-3">
              <h6 className="text-white font-bold mb-4 sm:mb-6 text-xs sm:text-sm uppercase tracking-widest">
                {t('footer.social_title')}
              </h6>

              <p className="text-sm text-slate-400 mb-6 leading-relaxed">
                {t('footer.social_subtitle')}
              </p>

              <div className="flex flex-wrap gap-4">
                {/* LinkedIn */}
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors duration-300" aria-label="LinkedIn">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/></svg>
                </a>

                {/* Facebook */}
                <a href="https://www.facebook.com/profile.php?id=100068557847220" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-blue-600 transition-colors duration-300" aria-label="LinkedIn">
                  <img src={require("../images/facebook.png") } alt="fb" className="w-6 h-6" />
                </a>

                {/* Twitter/X */}
                {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-blue-400 transition-colors duration-300" aria-label="Twitter">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/></svg>
                </a> */}

                {/* Instagram */}
                {/* <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-pink-600 transition-colors duration-300" aria-label="Instagram">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
                </a> */}

                {/* GitHub */}
                {/* <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-slate-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors duration-300" aria-label="GitHub">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/></svg>
                </a> */}
              </div>
            </div>

          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
            <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-slate-500">
              <p className="text-center sm:text-left">
                ©LAK-CHE 2026 | {t('footer.bottom.rights')}
              </p>
              <div className="flex flex-wrap justify-center sm:justify-end gap-4 sm:gap-6">
                <Link to="/security" className="hover:text-blue-400 transition-colors duration-300">{t('footer.bottom.security')}</Link>
                <Link to="/privacy-policy" className="hover:text-blue-400 transition-colors duration-300">{t('footer.bottom.privacy')}</Link>
                <Link to="/terms" className="hover:text-blue-400 transition-colors duration-300">{t('footer.bottom.terms')}</Link>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </>
  );
};

export default Footer;